<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .name -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('ac_qualifications.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('ac_qualifications.name')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/Ac_qualificationsController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "Ac_qualificationsForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.goToTable();
      }
    },
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
  },
};
</script>

